import React from 'react';
import { Link } from 'react-router-dom';
import logoth from '../../assets/logos/logo-th.svg';

function THlogo() {
  return (
    <div>
      <Link to="/restaurants">
        <img src={logoth} alt="logoth" />
      </Link>
    </div>
  );
}

export default THlogo;
